import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { styled, useResponsiveValue } from 'dripsy';

import { BaseText, Separator } from '@components';
import { CreditsStatusView } from './CreditsStatusView';
import { ResultView } from './ResultView';
import { IS_WEB } from '@utils';

const TopContainer = styled(View)({
  flexDirection: ['column', 'row'],
});

const ListHeaderContainer = styled(View)({
  flexDirection: ['column', 'row'],
  justifyContent: 'space-between',
});

const ListHeaderTitle = styled(BaseText)({
  color: '$heading800',
  variant: IS_WEB ? 'text.xxlarge' : 'text.xlarge',
  fontWeight: 'semi',
});

export const TrackFeedbackItemsListHeaderComponent = observer(() => {
  const { t } = useTranslation();
  // TODO:: Make vertical prop is responsive by default and remove this hook
  const isVertical = useResponsiveValue([false, true]);

  return (
    <Fragment>
      <TopContainer>
        <ResultView />
        <Separator vertical={isVertical} size="$5" />
        <CreditsStatusView />
      </TopContainer>

      <Separator size="$9" />

      <ListHeaderContainer>
        <ListHeaderTitle>
          {t('trackFeedback.activeTrackTitle')}
        </ListHeaderTitle>
      </ListHeaderContainer>
      <Separator size="$6" />
    </Fragment>
  );
});
